import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconArrowPoint = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 11,
	viewBox: "0 0 13 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0.191406 5.79688C0.0546875 5.66016 0 5.49609 0 5.30469C0 5.14062 0.0546875 4.97656 0.191406 4.83984L5.00391 0.246094C5.27734 0 5.6875 0 5.93359 0.273438C6.17969 0.519531 6.17969 0.957031 5.90625 1.20312L2.26953 4.64844H11.5938C11.9492 4.64844 12.25 4.94922 12.25 5.30469C12.25 5.6875 11.9492 5.96094 11.5938 5.96094H2.26953L5.90625 9.43359C6.17969 9.67969 6.17969 10.0898 5.93359 10.3633C5.6875 10.6367 5.27734 10.6367 5.00391 10.3906L0.191406 5.79688Z",
		fill: "#38539A"
	})]
});
const ForwardRef = forwardRef(SvgIconArrowPoint);
export { ForwardRef as ReactComponent };
